import { useCallback } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import {
  changeDeflectFilters,
  changeDeflectPageFilters,
  openDeflectPage,
  selectDeflectFilters,
  selectDeflectPageFilters
} from "../redux/deflectAnalytics.slice"
import { PROGRAM_OPTIONS } from "../utils/vocabulary"

// The Analytics page's filters, or with `page` (an inner page's route) that page's own window,
// which never reaches the Analytics page (RCA-12-01).
export const useDeflectFilters = (page) => {
  const dispatch = useDispatch()
  const filters = useSelector(page ? selectDeflectPageFilters(page) : selectDeflectFilters)
  const change = useCallback(
    (patch) =>
      dispatch(page ? changeDeflectPageFilters({ page, patch }) : changeDeflectFilters(patch)),
    [dispatch, page]
  )

  return { filters, change }
}

// How many programs the page covers: the picked ones, or every program when none is picked.
export const useProgramCount = (page) => {
  const { filters } = useDeflectFilters(page)

  return filters.program?.length || PROGRAM_OPTIONS.length
}

// Opens an inner page on the Analytics page's current window. Copied at the click, so a page whose
// URL is opened directly starts on the default instead.
export const useOpenDeflectPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const filters = useSelector(selectDeflectFilters)

  return useCallback(
    (page, state) => {
      dispatch(openDeflectPage({ page, filters }))
      navigate(page, { state })
    },
    [dispatch, navigate, filters]
  )
}
